import Header from '../../Components/Header';
import TextInput from '../../Components/TextInput';
import ChevronRight from '../../Images/chevron-right.svg';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import './NewsDetailPage.css';
import ImageInput from '../../Components/ImageInput';
import Select from 'react-select';
import { useNewsDetailPage } from './useNewsDetailPage';

import { Controller } from 'react-hook-form';

const NewsDetailPage = () => {
	const {
		navigate,
		olibLibraries,
		variant,
		handleChangeSelectInstitution,
		control,
		errors,
		onSubmit,
		handleSubmit,
		getValues,
		isSubmitting,
		enabled,
		id,
		handleActivateNews,
		handleDesactivateNews,
	} = useNewsDetailPage();

	return (
		<>
			<Header />

			<div className='flex flex-col items-center'>
				<div className='content w-full max-w-[1280px] flex flex-col items-center pb-48'>
					<h1 className='text-3xl font-bold pt-8 pb-12'>News Detail</h1>

					<form
						onSubmit={handleSubmit(onSubmit)}
						className='w-full bg-white p-2 lg:p-8 shadow-md rounded-xl gap-y-12 flex flex-col'
					>
						{/* Back Btn */}
						<button
							className='flex items-center gap-1 text-[#1B2831]'
							onClick={() => navigate('/news')}
						>
							<div className=' rotate-180'>
								<img src={ChevronRight} alt='Next' />
							</div>
							{variant === 'create' ? 'Create' : 'Edit'} a new post
						</button>

						{variant === 'edit' && (
							<div className=' '>
								<div className='flex items-center'>
									<div className='block text-xl text-black font-semibold mr-4'>
										Status
									</div>
									<div
										className={`${
											enabled ? 'tag-news-active' : 'tag-news-inactive'
										}`}
									>
										{enabled ? 'Active' : 'Inactive'}
									</div>
								</div>

								<div>
									<button
										className={`${
											enabled ? 'desactivate-news-btn' : 'publish-btn'
										} disabled:opacity-50 disabled:cursor-not-allowed`}
										type='button'
										onClick={() =>
											enabled
												? handleDesactivateNews(id)
												: handleActivateNews(id)
										}
									>
										{enabled ? 'Disable' : 'Enable'}
									</button>
								</div>
							</div>
						)}

						<div>
							<Controller
								name='title'
								control={control}
								render={({ field }) => (
									<TextInput
										{...field}
										label={'Title'}
										placeholder='Title...'
									/>
								)}
							/>
							{errors.title && (
								<p className='mt-1 text-sm text-red-500'>
									{errors.title.message}
								</p>
							)}
						</div>

						<div>
							<Controller
								name='description'
								control={control}
								render={({ field }) => (
									<TextInput
										{...field}
										label={'Description'}
										placeholder='Description...'
									/>
								)}
							/>
							{errors.description && (
								<p className='mt-1 text-sm text-red-500'>
									{errors.description.message}
								</p>
							)}
						</div>

						<div>
							<div className=' text-xl text-black font-semibold mb-2'>
								Paragraph
							</div>

							<Controller
								name='rich_text'
								control={control}
								render={({ field }) => (
									<ReactQuill
										{...field}
										modules={{
											toolbar: [
												[{ header: '1' }, { header: '2' }],
												[{ size: [] }],
												['bold', 'italic', 'underline', 'strike', 'blockquote'],
												[
													{ list: 'ordered' },
													{ list: 'bullet' },
													{ indent: '-1' },
													{ indent: '+1' },
												],
												['link', 'image', 'video'],
												['clean'],
											],
										}}
										theme='snow'
									/>
								)}
							/>

							{errors.rich_text && (
								<p className='mt-1 text-sm text-red-500'>
									{errors.rich_text.message}
								</p>
							)}
						</div>

						<div>
							<Controller
								name='image'
								control={control}
								render={({ field }) => (
									<ImageInput
										fileName={field.value?.[0]?.name ?? getValues('image')}
										onChange={(e) => field.onChange(e.target.files)}
										previewUrl={getValues('image') ? getValues('image') : ''}
									/>
								)}
							/>
							{errors.image && (
								<p className='mt-1 text-sm text-red-500'>
									{errors.image.message}
								</p>
							)}
						</div>

						<div>
							<div className='text-xl text-black font-semibold mb-2'>
								Select Institution
							</div>
							<Controller
								name='institution_codes'
								control={control}
								render={({ field }) => (
									<Select
										{...field}
										options={olibLibraries}
										isMulti
										className='basic-multi-select'
										onChange={(selected) =>
											handleChangeSelectInstitution(selected, field)
										}
									/>
								)}
							/>
							{errors.institution_codes && (
								<p className='mt-1 text-sm text-red-500'>
									{errors.institution_codes.message}
								</p>
							)}
						</div>

						<div className='flex justify-end'>
							<button
								className='publish-btn disabled:opacity-50 disabled:cursor-not-allowed'
								type='submit'
								disabled={isSubmitting}
							>
								{variant === 'create' ? 'Publish' : 'Save'} News
							</button>
						</div>
					</form>
				</div>
			</div>
		</>
	);
};

export default NewsDetailPage;
